var React = require('react');

function BabySeats (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.627 4.519A2.261 2.261 0 007.886 2.26 2.256 2.256 0 005.627.001a2.255 2.255 0 00-2.26 2.259 2.261 2.261 0 002.26 2.259zm0 .344h-1.37c-.429.003-.697.158-.944.4L.292 8.294c-.829.83.29 1.888 1.116 1.062l1.824-1.842v.593l3.243-3.243h-.848zM10.99 8.33L8.001 5.332 4.087 9.247h3.908V7.504l1.878 1.878c.755.799 1.904-.269 1.117-1.052zm-3.004 1.806L6.19 11.932l1.324 1.315L6.163 14.6a.795.795 0 001.125 1.116l2.132-2.223c.462-.47.588-1.334.1-1.824a1110.01 1110.01 0 01-1.534-1.533zm-4.273 3.112l1.315-1.315-1.797-1.796s-1.524 1.53-1.524 1.533c-.493.489-.367 1.354.091 1.824l2.142 2.223c.821.82 1.92-.32 1.126-1.116l-1.353-1.353z"}));
}

BabySeats.defaultProps = {"width":"11.254","height":"16","viewBox":"0 0 11.254 16"};

module.exports = BabySeats;

BabySeats.default = BabySeats;
